// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"216":"76ab5628","232":"0e5f9c7e","426":"9b2709c0","653":"5fe464d1","717":"6386edf8","754":"37c19e81","770":"586dc3e0","909":"bfce6f53"}[chunkId] + ".js";
};